import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';
import { useTranslations } from 'use-intl';

import { PageHeader } from '@/components/dashboard/page-header';
import { ProjectTasksClient } from '@/components/project/project-tasks-client';
import { trpc } from '@/lib/trpc/client';

export const Route = createFileRoute('/_app/projects/$id/tasks')({
  component: ProjectTasksPage,
});

function ProjectTasksPage(): React.ReactElement {
  const { id } = Route.useParams();
  const t = useTranslations('project.tasks');
  const meQuery = trpc.user.me.useQuery();

  return (
    <div className="flex flex-col gap-6">
      <PageHeader title={t('pageTitle')} subtitle={t('pageSubtitle')} />
      {meQuery.data ? (
        <ProjectTasksClient projectId={id} currentUserId={meQuery.data.id} />
      ) : (
        <p className="text-muted-foreground text-sm">{t('loading')}</p>
      )}
    </div>
  );
}
